import React from 'react'
import { SvgIconProps } from '@mui/material'
import { WithQueryWappRoomListItemTitle } from './with-query-wapp-room-list-item-title'
import { WithQueryWappRoomListItemStatus } from './with-query-wapp-room-list-item-status'
import { ChatListItem } from '../chat-list-item'
import { WappAvatar } from '$common/avatar/wapp-avatar'
import { nothing } from '$func/utils'
import { useWappRoom } from '$logic/wapp-room/react-hook'
import { useWapp } from '$logic/wapps/react-hook'
import { AvatarSize } from '$common/avatar/avatar-base/types'

interface Props {
  roomId: string
  SecondaryActionIcon?: React.ComponentType<SvgIconProps>
  hasDivider?: boolean
  onClick?: () => unknown
  onSecondaryActionIconClick?: () => unknown
  onContextMenu?: (e: Event) => unknown
  selected?: boolean
  searchQuery: string
}

export function SearchedWappRoomListItemWithStatus({
  roomId,
  SecondaryActionIcon,
  hasDivider = true,
  onClick = nothing,
  onSecondaryActionIconClick = nothing,
  selected = false,
  onContextMenu = nothing,
  searchQuery,
}: Props) {
  const { entity: wappRoom } = useWappRoom(roomId)
  const { wappId = '' } = wappRoom || {}
  const { entity: wapp } = useWapp(wappId)

  return (
    <ChatListItem
      avatarComponent={
        <WappAvatar wappId={wappId} selected={selected} size={AvatarSize.MD} />
      }
      primaryText={
        <WithQueryWappRoomListItemTitle wappId={wappId} query={searchQuery} />
      }
      secondaryText={<WithQueryWappRoomListItemStatus />}
      SecondaryActionIcon={SecondaryActionIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
      verified={wapp?.verified}
    />
  )
}
